"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.undoCancel_bff = exports.resume_bff = exports.submitCheckoutStatus_bff = exports.submitInitiateCheckout_bff = exports.submitCheckout_bff = void 0;
var tslib_1 = require("tslib");
var interfaces_1 = require("../../common/interfaces");
var common_1 = require("../../common");
var transformClientAnnotationToBffInput_1 = require("../../common/transforms/transformClientAnnotationToBffInput");
var transformClientBillingAddressToBffInput_1 = require("../../common/transforms/transformClientBillingAddressToBffInput");
var transformCartMetadatatoBffInput_1 = require("../../common/transforms/transformCartMetadatatoBffInput");
var submitCheckout_bff = function (checkoutData, cartId) {
    var _a = checkoutData.data, billing = _a.billing, payment = _a.payment, hostAnnotations = _a.hostAnnotations, deviceData = _a.deviceData;
    var paymentMethod = {
        id: payment === null || payment === void 0 ? void 0 : payment.cardId,
    };
    var bffVariables = {
        input: tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({ cartId: cartId, paymentMethods: [paymentMethod] }, (billing && {
            billingAddress: (0, transformClientBillingAddressToBffInput_1.transformClientBillingAddressToBffCartInput)(billing),
        })), (hostAnnotations && {
            annotations: (0, transformClientAnnotationToBffInput_1.transformClientAnnotationToBffInput)(hostAnnotations),
        })), (deviceData && { deviceData: deviceData })),
    };
    return (0, common_1.sendBFFCall)(interfaces_1.GraphQLOperations.CHECKOUT, bffVariables, common_1.cartCheckoutGraphRequestToCheggResponse);
};
exports.submitCheckout_bff = submitCheckout_bff;
var submitInitiateCheckout_bff = function (checkoutData, cartId, redirectUrl) {
    var _a = checkoutData.data, billing = _a.billing, payment = _a.payment, hostAnnotations = _a.hostAnnotations, deviceData = _a.deviceData;
    var paymentMethod = {
        id: payment === null || payment === void 0 ? void 0 : payment.cardId,
    };
    var bffVariables = {
        input: tslib_1.__assign(tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({ cartId: cartId, paymentMethods: [paymentMethod] }, (billing && {
            billingAddress: (0, transformClientBillingAddressToBffInput_1.transformClientBillingAddressToBffCartInput)(billing),
        })), (hostAnnotations && {
            annotations: (0, transformClientAnnotationToBffInput_1.transformClientAnnotationToBffInput)(hostAnnotations),
        })), (deviceData && { deviceData: deviceData })), (redirectUrl && {
            cartMetadata: (0, transformCartMetadatatoBffInput_1.transformCartMetadatatoBffInput)(redirectUrl),
        })),
    };
    return (0, common_1.sendBFFCall)(interfaces_1.GraphQLOperations.INITIATE_CHECKOUT, bffVariables, common_1.cartCheckoutGraphRequestToCheggResponse);
};
exports.submitInitiateCheckout_bff = submitInitiateCheckout_bff;
var submitCheckoutStatus_bff = function (cartId) {
    var bffVariables = {
        input: {
            cartId: cartId,
        },
    };
    return (0, common_1.sendBFFCall)(interfaces_1.GraphQLOperations.CHECKOUT_STATUS, bffVariables, common_1.cartCheckoutGraphRequestToCheggResponse);
};
exports.submitCheckoutStatus_bff = submitCheckoutStatus_bff;
var resume_bff = function (params) { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
    var bffVariables;
    return tslib_1.__generator(this, function (_a) {
        bffVariables = {
            input: { actionName: 'RESUME', orderLineId: params.orderLineId },
        };
        return [2 /*return*/, (0, common_1.sendBFFCall)(interfaces_1.GraphQLOperations.ORDER_MANAGEMENT, bffVariables).catch(function (error) { return JSON.parse(error.message); })];
    });
}); };
exports.resume_bff = resume_bff;
var undoCancel_bff = function (params) { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
    var bffVariables;
    return tslib_1.__generator(this, function (_a) {
        bffVariables = {
            input: { actionName: 'RESTART', orderLineId: params.orderLineId },
        };
        return [2 /*return*/, (0, common_1.sendBFFCall)(interfaces_1.GraphQLOperations.ORDER_MANAGEMENT, bffVariables).catch(function (error) { return JSON.parse(error.message); })];
    });
}); };
exports.undoCancel_bff = undoCancel_bff;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/checkout-sdk/dist/lib-esm/modules/checkoutAPI/bff/index.js
// module id = 3348
// module chunks = 11